(function () {

    angular
        .module('smartertoolsApp')
        .directive('stNoItems', [stNoItems]);

    function stNoItems() {
        return {
            template: "<div class='no-items-directive'>There are no items to show in this list</div>"
        };
    }

})();